globalThis.backoffice = globalThis.backoffice || {};

backoffice.GlobalSearch = (function()
{
  function GlobalSearch($container) {
    this.$globalSearch = $container;
    this.$globalSearchResults = this.$globalSearch.find('.global-search-results');
    this.globalSearchTimeout = null;

    this.events();
  }

  GlobalSearch.prototype = {
    events: function() {
      var self = this,
          results = {},
          currentSearchQuery;

      self.$globalSearch.on('keyup', 'input', function(e) {
        if(self.globalSearchTimeout) clearTimeout(self.globalSearchTimeout);
        self.$globalSearch.addClass('typing');

        var $this = $(this),
            q = $this.val(),
            source = $this.data('source');

        currentSearchQuery = q;

        if(e.keyCode == 13 || !q) {
          self.$globalSearch.removeClass('typing');
        }

        if(source && q.length > 2) {
          self.$globalSearch.addClass('open');

          if(results[q]) {
            self.$globalSearchResults.show().html(results[q].html);
          } else {
            self.globalSearchTimeout = setTimeout(function() {
              self.$globalSearch.removeClass('typing').addClass('ui-autocomplete-processing');

              $.get(source, { q: q }, function(data) {
                if(currentSearchQuery == q) {
                  if(data.response) {
                    result_keys = Object.keys(results)

                    if(result_keys.length == 100) {
                      delete results[result_keys[0]];
                    }

                    results[q] = data

                    self.$globalSearchResults.show().html(data.html);
                  }
                }

                self.$globalSearch.removeClass('ui-autocomplete-processing');
              });
            }, 300);
          }
        } else {
          self.$globalSearch.removeClass('open');
          self.$globalSearchResults.hide();
        }
      }).on('click', 'input', function() {
        if($(this).is(':focus') && self.$globalSearchResults.is(':visible')) {
          return false;
        }
      });
    }
  }

  return GlobalSearch;
})();
